var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiTransferIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7 4.413v-1a.5.5 0 0 0-.5-.5H4v-1.5a.5.5 0 0 0-.82-.384l-3 2.5a.5.5 0 0 0 0 .768l3 2.5a.494.494 0 0 0 .532.069A.5.5 0 0 0 4 6.413v-1.5h2.5a.5.5 0 0 0 .5-.5ZM11.82 9.53l-3-2.5a.5.5 0 0 0-.82.383v1.5H5.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H8v1.5a.5.5 0 0 0 .82.384l3-2.5a.5.5 0 0 0 0-.768Z"
})));
export default SvgHaidiTransferIcon;